const DATABASE_NAME = 'dezshop-task-notifications';
const STORE_NAME = 'claimed';

const isValidId = (value) => (
  (typeof value === 'number' && Number.isFinite(value) && value > 0)
  || (typeof value === 'string' && value.trim().length > 0)
);

function openDatabase() {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DATABASE_NAME, 1);
    let blocked = false;
    request.onupgradeneeded = () => request.result.createObjectStore(STORE_NAME);
    request.onsuccess = () => {
      if (blocked) request.result.close();
      else resolve(request.result);
    };
    request.onerror = () => reject(request.error);
    request.onblocked = () => {
      blocked = true;
      reject(new Error('Task notification storage is blocked'));
    };
  });
}

// IndexedDB's read/write transaction is shared across tabs. A per-tab Set or
// a localStorage read followed by a write would let simultaneous deliveries
// both win. Keep only IDs, with no expiry, so delayed tabs/reloads stay silent.
export async function claimTaskNotification({ userId, taskType, taskId }) {
  if (!isValidId(userId) || !isValidId(taskId) || !['crm', 'legacy'].includes(taskType)) {
    return false;
  }

  let database;
  try {
    database = await openDatabase();
    return await new Promise((resolve, reject) => {
      const transaction = database.transaction(STORE_NAME, 'readwrite');
      const request = transaction.objectStore(STORE_NAME).add(
        true, [String(userId), taskType, String(taskId)],
      );
      transaction.oncomplete = () => resolve(true);
      transaction.onabort = () => {
        if (request.error?.name === 'ConstraintError') resolve(false);
        else reject(transaction.error || request.error);
      };
    });
  } catch (error) {
    // Counts and task lists still update if storage is unavailable. Do not
    // turn a storage failure into the same alert ringing in every tab again.
    console.warn('Could not claim task notification:', error);
    return false;
  } finally {
    database?.close();
  }
}
